import { useState, useEffect, useMemo } from 'react';
import { newMathFormat } from '@/pages/intelligence/utils/commonUtils';
import { ECHARTSCOLOR } from '@/pages/intelligence/utils/echartsConst';
import { createDataSourceMetricForValue } from '@/pages/intelligence/pages/Following/_config/util';

export interface BarChartData {
  seriesData: any[];
  barNameList: any[];
}

export default function useNewGameBarCharts(
  metric: string,
  barData: any[],
): BarChartData {
  // 柱状图 相关配置
  // 柱状图 y轴数据
  const [seriesData, setSeriesData] = useState<any>([]);

  const getValue = (list: any[]) => {
    if (metric === 'potential') {
      return list?.length > 0
        ? list?.find((item: any) => item.metric == metric)?.value
        : '';
    }
    return list?.length > 0
      ? list?.find((item: any) => createDataSourceMetricForValue(item?.metric, item?.data_source) == metric)?.value
      : '';
  };

  // 获取 seriesData
  const createSeriesData = (data: any[]): any[] => {
    if (!Array.isArray(data) || data?.length < 1) return [];
    return data.map((item: any, i: number): any => ({
      type: 'bar',
      name: item.gameName || item.name,
      value: getValue(item.metric_list ? item.metric_list : []),
      cover: item.gameIcon || item.cover || item.market,
      itemStyle: {
        color: ECHARTSCOLOR[i],
      },
      label: {
        show: true,
        position: 'top',
        color: '#444',
        distance: 4,
        fontSize: 12,
        formatter: (params: any) =>
          `${newMathFormat(Number(params.value), true)}`,
      },
    }));
  };

  useEffect(() => {
    setSeriesData(createSeriesData(barData));
  }, [metric, barData]);

  const barNameList = useMemo(() => {
    return Array.isArray(barData) && barData?.length > 0
      ? barData?.map((item: any, i: number): any =>
          item ? item.gameName || item.name : '',
        )
      : [];
  }, [barData]);

  return {
    seriesData,
    barNameList,
  };
}
